export default "/images/e13fa9c422876b1527bbda45ae1a5ec0.avif";